import type { ReactNode } from 'react';

export function Modal({ title, onClose, children, footer }: { title: string; onClose: () => void; children: ReactNode; footer?: ReactNode }) {
  return (
    <div
      className="fixed inset-0 z-[200] flex items-start justify-center p-4 sm:p-8 overflow-auto bg-navy/25 backdrop-blur-sm"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-2xl border border-line w-full max-w-[760px] shadow-sh2 overflow-hidden flex flex-col max-h-[calc(100vh-3rem)]"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex justify-between items-center gap-3 px-5 py-3.5 border-b border-line-2 bg-canvas shrink-0">
          <h3 className="text-navy text-[15px] font-semibold truncate">{title}</h3>
          <button
            onClick={onClose}
            aria-label="Close"
            className="shrink-0 w-7 h-7 rounded-lg flex items-center justify-center text-muted hover:text-navy hover:bg-line text-[19px] leading-none transition-colors"
          >
            ×
          </button>
        </div>
        <div className="px-5 py-4 overflow-y-auto">{children}</div>
        {footer && <div className="flex gap-2 justify-end px-5 py-3 border-t border-line-2 bg-canvas shrink-0">{footer}</div>}
      </div>
    </div>
  );
}
